module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ep-sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "epv-top",
    attrs: {
      "id": "epi"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Every ending is arbitrary, because the end is where you write")]), _vm._v(" The end"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v(". A period, a dot of punctuation, a point of stasis.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A pinprick in the paper: you could put your eye to it and see")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("through, to the other side, to the beginning of something else.")])]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("—Margaret Atwood, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Robber Bride")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542f3a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0